var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"change-device",class:[
      _vm.deviceTrigger,
      _vm.device == _vm.deviceTrigger ? 'active': ''
    ],on:{"click":function($event){return _vm.displayOn(_vm.deviceTrigger)}}},[_c('i',{staticClass:"material-symbols-outlined"},[_vm._v(_vm._s(_vm.icon))])])])}
var staticRenderFns = []

export { render, staticRenderFns }